import React, { useState, useEffect, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { InputText, Button } from '@increasecard/typed-components';
import { useShallowEqualSelector } from '../../../utils/reduxUtils';
import { BusinessActions } from '../actions/businessActions';

export function BusinessNameForm() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const business = useShallowEqualSelector((state) => state.business);
  const [businessName, setBusinessName] = useState(business.name);

  const saveBusinessName = () => dispatch(BusinessActions.putBusinessName(businessName));
  const updateNameFailed = business.status === 'FETCH_ERROR';
  const disableSaveName = businessName === business.name || business.status === 'FETCHING_NAME';

  useEffect(() => {
    setBusinessName(business.name);
  }, [business.name]);

  useEffect(() => {
    dispatch(BusinessActions.fetch());
  }, [dispatch]);

  return (
    <div style={{ display: 'inline-flex', alignItems: 'flex-end' }}>
      <InputText
        errorMessage={updateNameFailed && t(`abm:Business:nameError`)}
        id="companyNameInput"
        label={t(`abm:Business:companyName`)}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setBusinessName(e.target.value)}
        value={businessName}
        width="300px"
      />
      <Button disabled={disableSaveName} onClick={saveBusinessName} style={{ marginLeft: '16px' }}>
        {t('common:save')}
      </Button>
    </div>
  );
}
